angular.module('lingoda.fields', [])
//Fix for default input value
.directive('input', ['$parse', function($parse) {
    return {
        restrict: 'E',
        link: function (scope, element, attrs) {

            if (attrs.ngModel && attrs.value && attrs.type !== 'radio'  && attrs.type !== 'checkbox' && attrs.type !== 'hidden') {
                $parse(attrs.ngModel).assign(scope, attrs.value);
            }

            if(attrs.type === 'checkbox' && attrs.ngModel && scope.getOriginalValue) {
               scope.setFieldValue(attrs.ngModel, scope.getOriginalValue(attrs.ngModel));
            }

            //Hidden field
            if(attrs.type === 'hidden' && attrs.ngModel) {
                scope.$watch(attrs.ngModel, function(v) {
                    element.val(v);
                });
            }
        }
    }
}])
.directive('textarea', ['$parse', function($parse) {
    return {
        restrict: 'E',
        link: function (scope, element, attrs) {
            if (attrs.ngModel && element.val()) {
                $parse(attrs.ngModel).assign(scope, element.val());
            }
        }
    }
}]);
